import { DetailsRow, IColumn, Text } from "@bps/fluent-ui";
import { HttpError } from "@bps/http-client";
import { ShimmeredDetailsList } from "@components/tables/ShimmeredDetailsList";

interface DeviceConnectivityTableProps {
  items: OverviewTableItem[];
  error?: HttpError;
  isLoading?: boolean;
}

export interface OverviewTableItem {
  Name: string;
  Value: JSX.Element;
}

export const DeviceConnectivityTable = ({
  items,
  error,
  isLoading
}: DeviceConnectivityTableProps) => {
  const columns: IColumn[] = [
    {
      key: "Item Name",
      name: "",
      minWidth: 100,
      maxWidth: 250,
      isResizable: true,
      onRender: (item: OverviewTableItem) => <Text bold>{item.Name}</Text>
    },
    {
      key: "Item Value",
      name: "",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      onRender: (item: OverviewTableItem) => item.Value
    }
  ];

  return (
    <ShimmeredDetailsList
      enableShimmer={isLoading}
      errorMessage={error?.message}
      isSelectedOnFocus
      columns={columns}
      detailsListStyles={{
        root: {
          ".ms-DetailsHeader": {
            height: "15px" // This is used to remove height of table headers (as they are not needed)
          }
        },
        contentWrapper: { width: "50px" },
        focusZone: { width: "50px" },
        headerWrapper: { width: "50px" }
      }}
      styles={{ root: { width: "200px" } }}
      items={items}
      onRenderRow={row =>
        row ? <DetailsRow styles={{ cell: { height: 55 } }} {...row} /> : null
      }
    />
  );
};
